import React from 'react';

/**
 * Error boundary for lazily-loaded, non-critical UI (e.g. floating widgets).
 *
 * When a dynamic import() rejects — typically because a deploy removed the hashed
 * chunk this client's cached shell points at — React re-throws the rejection
 * during render. With no boundary that unmounts the ENTIRE app (blank page). This
 * boundary contains the failure to its children so the rest of the page keeps
 * working; the inline self-heal guard in public/index.html separately attempts a
 * bounded, cache-busting reload to fetch the fresh chunk.
 */
class LazyBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    // eslint-disable-next-line no-console
    console.warn('[LazyBoundary] Suppressed lazy component failure:', error?.message || error);
  }

  render() {
    if (this.state.hasError) return this.props.fallback || null;
    return this.props.children;
  }
}

export default LazyBoundary;
